import * as React from 'react';
import { Typography } from '@/components/common';
import { ClientTargetResult } from '@/interfaces';

export const CaseMetricsClientTarget = ({
	clientTarget,
}: {
	clientTarget: ClientTargetResult[];
}) => {
	return (
		<div className="grid px-4  grid-cols-1 lg:grid-cols-2 gap-3 lg:px-0 lg:gap-12">
			<div className="grid grid-cols-1 border-b pb-3 border-[#0D061614] lg:pb-0 lg:border-b-0 lg:border-r">
				<Typography
					type="semibold-16"
					className="text-grey-80 mb-1 text-center !text-[16px] !leading-[19.2px]"
				>
					Percentage of Target Met
				</Typography>
				<Typography
					type="semibold-28"
					className="text-grey-90 text-center !text-[28px] !leading-[33.6px]"
				>
					{clientTarget[0].percentage_of_target_met || '0'}%
				</Typography>
			</div>
			<div className="flex flex-col gap-y-1 pr-4 lg:pr-[70px]">
				<div className="flex justify-between w-full">
					<Typography type="semibold-12" className="text-grey-80 text-start">
						Target Goal
					</Typography>
					<Typography
						type="semibold-20"
						className="text-grey-90 text-start !text-[20px] leading-[24px]"
					>
						{clientTarget[0].target_goal || '0'}
					</Typography>
				</div>

				<div className="flex justify-between w-full">
					<Typography type="semibold-12" className="text-grey-80 text-start">
						Eligible Clients to Date
					</Typography>
					<Typography
						type="semibold-20"
						className="text-grey-90 text-start !text-[20px] leading-[24px]"
					>
						{/* {clientTarget[0].eligible_clients_to_date || '0'} */}
						{clientTarget[0].eligible_clients_to_date || '0'}
					</Typography>
				</div>
			</div>
		</div>
	);
};
